import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  Typography,
  Select,
  MenuItem,
  TextField,
  Checkbox,
  FormControlLabel,
  Chip,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Autocomplete } from "@material-ui/lab";
import TableView from "../../../CustomComponent/TableView";
import socket from "../../../socket/socket";

function ExtraTime() {
  const classes = useStyles();

  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const Heading = [
    {
      height: "maxh43",
      style: "viewtable",
      checkboxselection: "true",
    },
  ];

  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();
  const [selectedLearner, setSelectedLearner] = useState([]);
  const [selectedLearnerId, setSelectedLearnerId] = useState([]);
  const [learners, setLearners] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [search, setSearch] = useState("");

  const handleClose = () => {
    navigate("/admin/dashboard");
  };

  const [center, setCenter] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState("");

  const [cources, setCources] = useState([]);
  const [selectedCource, setSelectedCource] = useState("");

  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");

  const [exams, setExams] = useState([]);
  const [selectedExam, setSelectedExam] = useState(null);
  const [selectedExamId, setSelectedExamId] = useState("");

  const [duration, setDuration] = useState("");

  const fetchCenter = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/filter/all`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            // Add other headers if needed
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setCenter(data.centers);
      } else {
        console.error("Failed to fetch center data");
      }
    } catch (error) {
      console.error("Error fetching center data:", error);
    }
  };

  useEffect(() => {
    fetchCenter();
  }, []);

  useEffect(() => {
    socket.connect();
    return () => {
      socket.disconnect();
    };
  }, []);

  const fetchCources = async (selectedCenter) => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/centerid/${selectedCenter}`,

        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            // Add other headers if needed
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setCources(data.center.courses);
      } else {
        console.error("Failed to fetch batches data");
      }
    } catch (error) {
      console.error("Error fetching batches data:", error);
    }
  };

  useEffect(() => {
    fetchCources(selectedCenter);
  }, [selectedCenter]);

  const fetchBatches = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      // Ensure selectedCourses is not empty before making the request
      if (selectedCenter && selectedCource) {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/centers/course`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              center: {
                centerId: selectedCenter,
                courseId: selectedCource,
              },
            }),
          }
        );
        if (response.ok) {
          const data = await response.json();
          setBatches(data.center.batches);
        } else {
          console.error("Failed to fetch batches data:", response);
        }
      }
    } catch (error) {
      console.error("Error fetching batches data:", error);
    }
  };

  useEffect(() => {
    fetchBatches();
  }, [selectedCenter, selectedCource]);

  const fetchExam = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      // Ensure selectedCourses is not empty before making the request
      if (selectedCenter && selectedCource && selectedBatch) {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/centers/course/batch/exam`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              center: {
                centerId: selectedCenter,
                courseId: selectedCource,
                batchId: selectedBatch,
              },
            }),
          }
        );
        if (response.ok) {
          const data = await response.json();
          setExams(data.center.exams);
        } else {
          console.error("Failed to fetch batches data:", response);
        }
      }
    } catch (error) {
      console.error("Error fetching batches data:", error);
    }
  };

  useEffect(() => {
    fetchExam();
  }, [selectedCenter, selectedCource, selectedBatch]);

  const handleCenterChange = (event) => {
    setSelectedCenter(event.target.value);
    setSelectedCource("");
    setSelectedBatch("");
    setSelectedLearner([]);
    setSelectedLearnerId([]);
  };

  const handleCourceChange = (event) => {
    setSelectedCource(event.target.value);
    setSelectedBatch("");
    setSelectedLearner([]);
    setSelectedLearnerId([]);
  };

  const handleBatchChange = (event) => {
    setSelectedBatch(event.target.value);
    setSelectedLearner([]);
    setSelectedLearnerId([]);
  };
  const handleLearnerChange = (event, value) => {
    setSelectedLearner(value.map((learner) => learner));
    setSelectedLearnerId(value.map((learner) => learner.id));
  };

  const handleSelectAllChange = () => {
    const allLearners = !selectAll ? learners : [];
    setSelectedLearner(allLearners);
    const selectedIds = allLearners.map((learner) => learner.id);
    setSelectedLearnerId(selectedIds);
    setSelectAll(!selectAll);
  };

  // console.log('selectedLearnerId' , selectedLearnerId)

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/learner/all/filter/started?course_id=${selectedCource}&batch_id=${selectedBatch}&center_id=${selectedCenter}&exam_id=${selectedExam}&search=${search}`,

        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      setLearners(response.data.learners);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedCenter, selectedCource, selectedBatch, selectedExam]);

  const handleExamChange = (event, value) => {
    setSelectedExam(value.id);
    setSelectedExamId(value);
    setSelectedLearner([]);
    setSelectedLearnerId([]);
  };

  const handleFormSubmit = () => {
    if (!selectedExam) {
      toast.warn("Please select a exam.");
      return;
    }
    if (!duration) {
      toast.warn("Please enter a extra time.");
      return;
    }
    if (Id.length === 0) {
      toast.warn("Please select a learners");
      return;
    }

    const data = {
      learner: {
        exam_id: selectedExam,
        extra_time: Number(duration),
        ids: Id,
      },
    };

    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/live/extratime`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setTimeout(() => {
          navigate("/admin/dashboard");
        }, 2000);
        if (selectedLearnerId.length === 0) {
          toast.success("Extra time added successfully");
          socket.emit("extratime", {
            examId: selectedExam,
            userIds: Id,
            extraTime: duration,
          });
        } else {
          toast.success("Extra time added successfully");
        }
      })
      .catch((error) => {
        toast.error("Failed to extra time added");
      });
  };

  let [Id, setId] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const handleCheckboxClick = (selectedIDs) => {
    setId(selectedIDs);
  };

  const rows = learners.map((d) => ({
    id: d?.user_id ? d.user_id : "N/A",
    full_name: d?.learner_name ? d?.learner_name : "N/A",
    roll_no: d?.roll_number ? d.roll_number : "N/A",
    phone: d?.phone ? d.phone : "N/A",
    email: d?.email ? d.email : "N/A",
    course_name: d?.course_name ? d.course_name : "N/A",
    center_code: `${d.center_code || "N/A"} - ${d.center_name || "N/A"}`,
    batch_name: d?.batch_name ? d.batch_name : "N/A",
    guardian_name: d?.learner_information?.guardian_name
      ? d.learner_information.guardian_name
      : "N/A",
    created_at: d?.created_at ? d?.created_at : "N/A",
    active_status: d?.active_status ? d?.active_status : "N/A",
  }));

  const filteredRows = rows
    .filter((d) => {
      const isSearchMatch = d.full_name
        .toLowerCase()
        .includes(searchQuery.toLowerCase());

      return isSearchMatch;
    })
    .map((row, index) => ({
      ...row,
      srno: index + 1,
    }));

  const columns = [
    {
      field: "roll_no",
      headerName: "Roll No.",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "full_name",
      headerName: "Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    // {
    //   field: "phone",
    //   headerName: "Ph.No.",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 110,
    //   flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    {
      field: "course_name",
      headerName: "Course",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      // type: "number",
      width: 110,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "batch_name",
      headerName: "Batch",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      // type: "number",
      width: 110,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "center_code",
      headerName: "Branch Code",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      // type: "number",
      width: 110,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
  ];

  return (
    <>
      <ToastContainer />

      <div
        className={`${classes.inputpadding} ${classes.inputborder} ${classes.maxh76}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.pt2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Extra Time
              </Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Branch <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="category-label"
                  id="state"
                  value={selectedCenter}
                  onChange={handleCenterChange}
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  {center &&
                    center.map((st) => (
                      <MenuItem key={st.id} value={st.id}>
                        {st.center_name}
                      </MenuItem>
                    ))}
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Course <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="category-label"
                  id="state"
                  value={selectedCource}
                  onChange={handleCourceChange}
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  {cources &&
                    cources.map((st) => (
                      <MenuItem key={st.id} value={st.id}>
                        {st.course_name}
                      </MenuItem>
                    ))}
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Batch <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="category-label"
                  id="batch"
                  value={selectedBatch}
                  onChange={handleBatchChange}
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  {batches &&
                    batches.map((st) => (
                      <MenuItem key={st.id} value={st.id}>
                        {st.batch_name}
                      </MenuItem>
                    ))}
                </Select>
              </div>
            </div>

            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Exam Name <span className={classes.textcolorred}>*</span>
                </FormLabel>
                {/* <Select
                  labelId="category-label"
                  id="batch"
                  value={selectedExam}
                  onChange={handleExamChange}
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  {exams &&
                    exams.map((st) => (
                      <MenuItem key={st.id} value={st.id}>
                        {st.exam_name}
                      </MenuItem>
                    ))}
                </Select> */}

                <Autocomplete
                  id="state-autocomplete"
                  options={exams || []}
                  value={selectedExamId}
                  classes={{ inputRoot: classes.inputRoot }}
                  onChange={handleExamChange}
                  disableClearable
                  getOptionLabel={(option) => option?.exam_name || ""}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Here"
                      variant="outlined"
                    />
                  )}
                  selectOnFocus
                  openOnFocus
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Duration in Seconds
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="number"
                  variant="outlined"
                  required
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                  // onChange={(e) => handleFormChange("duration", e.target.value)}
                  placeholder="Type Here"
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              ></div>
            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Search
              </Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Search
                </FormLabel>
                <TextField
                  type="text"
                  variant="outlined"
                  required
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Roll No./Student Name"
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <Button
                  className={`${classes.custombtnblue} ${classes.mt1_5}`}
                  onClick={fetchData}
                >
                  search
                </Button>
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              ></div>
            </div>

            {/* <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>

         

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w36_6}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Learner
                </FormLabel>
                <Autocomplete
                  multiple
                  id="learner-autocomplete"
                  required
                  options={learners || []}
                  disableClearable
                  disableCloseOnSelect={true}
                  value={selectedLearner}
                  onChange={(event, newValue) => {
                    setSelectedLearner(newValue);
                    const selectedIds = newValue.map((learner) => learner.id);
                    setSelectedLearnerId(selectedIds);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={selectAll}
                                  onChange={handleSelectAllChange}
                                />
                              }
                              label="Select All"
                            />
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  renderOption={(option, { selected }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                      }
                      label={option.full_name} // Display the full_name in the dropdown
                    />
                  )}
                  getOptionLabel={(option) => option.full_name} // Display the full_name as the selected value
                  renderTags={() => null}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  selectOnFocus
                  openOnFocus
                />
              </div>
            </div> */}

            <div
              className={`${classes.bgwhite} ${classes.dflex} ${classes.flexdirectioncolumn} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.mt1}`}
            >
              <TableView
                columns={columns}
                rows={filteredRows}
                Heading={Heading}
                onCheckboxClick={handleCheckboxClick}
              />
            </div>
          </div>
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              className={`${classes.custombtnoutline}`}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              className={`${classes.custombtnblue}`}
              onClick={handleFormSubmit}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default ExtraTime;
